import React, {
    useContext, useCallback, useState, useEffect
} from 'react';
import _ from 'lodash';
import { ModalNextProvider } from '@jutro/components';
import { TranslatorContext } from '@jutro/locale';
import { BreakpointTrackerContext } from '@jutro/layout';
import { WizardPage, wizardProps } from 'gw-portals-wizard-react';
import { ViewModelServiceContext, ViewModelForm } from 'gw-portals-viewmodel-react';
import { useDependencies } from 'gw-portals-dependency-react';
import { useAuthentication } from 'gw-digital-auth-react';
import { useValidation } from 'gw-portals-validation-react';
import { MockUpUtil } from 'gw-portals-util-js';
import { readViewModelValue } from 'gw-jutro-adapters-react';
import AdditionalInterestComponent from '../../components/AdditionalInterest/AdditionalInterestComponent';
import metadata from './VehiclesPage.metadata.json5';
import messages from './VehiclesPage.messages';
import styles from 'gw-capability-policyjob-react/components/VehicleComponent/VehicleComponent.module.scss';
import { ServiceManager } from '@jutro/services';

function VehiclesPage(props) {
    const { wizardData: submissionVM, updateWizardData } = props;
    const viewModelService = useContext(ViewModelServiceContext);
    const breakpoint = useContext(BreakpointTrackerContext);
    const translator = useContext(TranslatorContext);
    const [isPageInitialised, updateIsPageInitialised] = useState(false);
    const { LoadSaveService } = useDependencies('LoadSaveService');
    const localeService = ServiceManager.getService('locale-service');
    const [existingContacts, setExistingContacts] = useState([]);
    const [vehicleNumberMax, setVehicleNumberMax ] = useState(0);
    const { authHeader } = useAuthentication();
    const [isVinEditMode, setIsVinEditMode] = useState(false);
    const [garageLocationDetailsValidation, updategarageLocationDetailsValidation] = useState(false);
    const {
        onValidate,
        initialValidation,
        isComponentValid,
        disregardFieldValidation,
        registerInitialComponentValidation
    } = useValidation('VehiclePage');

    const validateVehicles = () => {
        let isValid = true;
        _.each(submissionVM.lobData.businessAuto.coverables.vehicles.children, (vehicle)=>{
            if(!vehicle.aspects.valid || !vehicle.aspects.subtreeValid){
                isValid = false;                
            }
        });
        return isValid;
    }

    const validateTelematics = useCallback(() => {
        let telematicsField = true;
        const isDriverEnrolled = submissionVM.lobData.businessAuto.coverables.value.drivers.filter((driver) => driver.isEnrolledInTelematics_EY === true).length > 0
        submissionVM.lobData.businessAuto.coverables.vehicles.value.filter((c) => {
            if (isDriverEnrolled) {
                if (c.isEnrolledForTeleDisc_EY === undefined || c.isEnrolledForTeleDisc_EY === '') {
                    telematicsField = false;
                } else {
                    telematicsField = true;
                }
            }
        });
        return telematicsField;
    }, [submissionVM]);


    const createVehicleVM = useCallback(() => {
        const vehicles = submissionVM.lobData.businessAuto.coverables.vehicles.value;
        if (_.isEmpty(vehicles)) {
            const accountHolder = submissionVM.baseData.accountHolder.value;
            const vehicleObj = {
                licenseState: accountHolder.primaryAddress.state,
                costNew: {
                    amount: ''
                },
                //primaryUse: 'pleasure',
                vehicleType: 'PrivatePassenger_EY',
                vehicleNumber: 1,
                purchasePrice: {},
                isValidationRequired : true
            };
            // eslint-disable-next-line max-len
            const { _xCenter, _dtoName } = submissionVM.lobData.businessAuto.coverables.vehicles;
            const vehicleVM = viewModelService.create(vehicleObj, _xCenter, _dtoName);
            submissionVM.lobData.businessAuto.coverables.vehicles.pushElement(vehicleVM);
            updateWizardData(submissionVM);
        }
    }, [submissionVM, updateWizardData, viewModelService]);

    useEffect(() => {
        if (!isPageInitialised) {
            const maxNumber = (submissionVM.lobData.businessAuto.coverables.vehicles.length > 0) ? _.max(submissionVM.lobData.businessAuto.coverables.vehicles.value.map((vehicle) => vehicle.vehicleNumber)) : 1;
            setVehicleNumberMax(maxNumber);

            const _existingContacts = submissionVM.baseData.account.accountContacts.value.map((c) => {
                c['id'] = c.publicID;
                return c;
            });
            const availableContacts = [{ id: "placeholder", displayName: "Add Additional Interest" }].concat(_existingContacts);
            setExistingContacts(availableContacts);

            const vehiclesPath = 'lobData.businessAuto.coverables.vehicles';
            const vehicles = _.get(submissionVM, `${vehiclesPath}.value`);

            const newVehicles = vehicles.map((vehicle, index) => {
                vehicle.isValidationRequired = true;
                const pathToCheckForMockData = `${vehiclesPath}.${index}`;
                const isLincenseNumberMocked = MockUpUtil.isValueMocked(
                    submissionVM.value,
                    'quote.ba',
                    `${pathToCheckForMockData}.license`
                );
                const isVINMocked = MockUpUtil.isValueMocked(
                    submissionVM.value,
                    'quote.ba',
                    `${pathToCheckForMockData}.vin`
                );
                const newVehicle = {
                    ...vehicle,
                    vin: isVINMocked ? undefined : vehicle.vin,
                    costNew: isLincenseNumberMocked
                        ? {
                            ...vehicle.costNew,
                            amount: undefined
                        }
                        : vehicle.costNew
                };
                if (isLincenseNumberMocked && newVehicle.license) {
                    delete newVehicle.license;
                }
                return newVehicle;
            });

            if (!_.isEqual(newVehicles, vehicles)) {
                _.set(submissionVM, `${vehiclesPath}.value`, newVehicles);
                updateWizardData(submissionVM);
            }

            if (_.isEmpty(vehicles)) {
                createVehicleVM();
            }
            updateIsPageInitialised(true);
        }
    }, [createVehicleVM, isPageInitialised, submissionVM, updateWizardData]);

    const addVehicle = useCallback(() => {
        const accountHolder = submissionVM.baseData.accountHolder.value;
        const vehicleObj = {
            licenseState: accountHolder.primaryAddress.state,
            costNew: {
                amount: ''
            },
            //primaryUse: 'pleasure',
            vehicleType: 'PrivatePassenger_EY',
           // vehicleNumber: submissionVM.lobData.businessAuto.coverables.vehicles.length > 0 ? submissionVM.lobData.businessAuto.coverables.vehicles.length + 1 : 1,
            vehicleNumber: vehicleNumberMax + 1,
            purchasePrice: {},
            isValidationRequired: true,
            resetVehicleGroups_EY : true
        };
        setVehicleNumberMax(vehicleNumberMax + 1);
        // eslint-disable-next-line max-len
        const { _xCenter, _dtoName } = submissionVM.lobData.businessAuto.coverables.vehicles;
        const vehicleVM = viewModelService.create(vehicleObj, _xCenter, _dtoName);
        submissionVM.lobData.businessAuto.coverables.vehicles.pushElement(vehicleVM);
        updateWizardData(submissionVM);
    }, [submissionVM, updateWizardData, viewModelService]);

    const removeVehicle = useCallback(
        (evt) => {
            const vehicleListPath = 'lobData.businessAuto.coverables.vehicles.value';
            const currentPath = evt.path;
            const vehiclePath = currentPath.replace(/\.children\.(\d+)/, '.children[$1].value');
            const vehicle = _.get(submissionVM, vehiclePath);
            const vehicleList = _.get(submissionVM, vehicleListPath);
            const vehicleIndex = vehicleList.findIndex(
                (driverFromList) => _.isEqual(driverFromList, vehicle)
            );

            ModalNextProvider.showConfirm({
                title: messages.removeVehicleTitle,
                message: messages.removeVehicleDescription,
                status: 'warning',
                icon: 'mi-error-outline'
            }).then(
                (results) => {
                    if (results === 'cancel') {
                        return _.noop();
                    }                    
                    const newVehicleList = _.remove(vehicleList,
                        (vehicleFromList) => _.isEqual(vehicleFromList, vehicle));

                    _.set(submissionVM, newVehicleList, vehicleListPath); 
                    //disregardFieldValidation(`vehicle${vehicleIndex}`);                   
                    updateWizardData(submissionVM);
                    return true;
                }, _.noop
            );
        },
        [disregardFieldValidation, submissionVM, updateWizardData]
    );

    const addAdditionalInterest = useCallback(
        (additionalInterestPath, contact) => {
            const vehicleAdditionalInterests = _.get(submissionVM, additionalInterestPath);

            // initialize additional interest VM
            vehicleAdditionalInterests.value = vehicleAdditionalInterests.value || [];

            const additionalInterestTypedPath = 'lobData.businessAuto.coverables.addInterestTypeCategory';
            let initialValue = {
                policyAdditionalInterest: {
                    subtype: 'Company',
                    isFromPortal: true,
                    primaryAddress: {
                        country: localeService.getDefaultCountryCode(),
                        isFromPortal: true
                    }
                }
            };

            if(contact) {
                initialValue = {
                    policyAdditionalInterest: contact
                };
            }

            const initialContext = {
                AdditionalInterestType: _.get(submissionVM, additionalInterestTypedPath)
            };
            const { _xCenter, _dtoName } = vehicleAdditionalInterests;

            const currentAdditionalInterest = viewModelService.create(
                initialValue,
                _xCenter,
                _dtoName,
                initialContext
            );

            vehicleAdditionalInterests.pushElement(currentAdditionalInterest);
            updateWizardData(submissionVM);
        },
        [submissionVM, updateWizardData, viewModelService]
    );

    const updateAdditionalInterests = useCallback(() => {
        const newSubmissionVM = viewModelService.clone(submissionVM);
        updateWizardData(newSubmissionVM);
    }, [submissionVM, updateWizardData]);

    const addAdditionalInterestToVehicle = (value, path, index) => {
        if (value == 'placeholder') {
            addAdditionalInterest(path);
            return
        }
        const contact = existingContacts.filter((c)=>{return c.publicID == value})[0]
        addAdditionalInterest(path, contact);
    }

    const garagelocationValidation = useCallback((valid) => {
        updategarageLocationDetailsValidation(valid);
    }, [updategarageLocationDetailsValidation]);

    const generateOverrides = useCallback(() => {
        const vehiclePath = 'lobData.businessAuto.coverables.vehicles';
        const vehicles = _.get(submissionVM, 'lobData.businessAuto.coverables.vehicles.value', []);

        const overrides = vehicles.map((vehicle, index) => {
            //let driverTitle = translator(messages.baVehicleTitleNumber);

            //if (vehicles.length > 1 && index !== 0) {
               let driverTitle = `${translator(messages.baVehicleTitleNumber)} ${(index + 1)}`;
            //}

            return {
                [`baDeleteVehicle${index}`]: {
                    visible: vehicles.length > 1
                },
                [`baVehicleTitle${index}`]: {
                    value: driverTitle
                },
                [`baAddAdditionalInterest${index}`]: {
                    onClick: () => addAdditionalInterest(
                        `${vehiclePath}.children[${index}].additionalInterests`
                    )
                },
                [`addAdditionalInterest${index}`]:{
                    availableValues: existingContacts,
                    onValueChange: (value) => { addAdditionalInterestToVehicle(value, `${vehiclePath}.children[${index}].additionalInterests`, index) }
                },
                [`additionalinterestcomponentId${index}`]: {
                    updateAdditionalInterests,
                    value: _.get(submissionVM, `${vehiclePath}.children[${index}]`)
                },
                [`vehicle${index}`]: {
                    submissionVM: submissionVM,
                    authHeader: authHeader,
                    updateWizardData: updateWizardData,
                    setIsVinEditMode: setIsVinEditMode,
                    locationValidation: (valid) => { garagelocationValidation(valid); }
                }
            };
        });

        return Object.assign({}, ...overrides);
    }, [addAdditionalInterest, submissionVM, translator, updateAdditionalInterests, existingContacts,setIsVinEditMode, isVinEditMode ]);

    const onNext = useCallback(async () => {
        let vehiclesList = submissionVM.lobData.businessAuto.coverables.vehicles.value;
        vehiclesList = vehiclesList.map((vehicle, index) => {
            vehicle['vehicleNumber'] = (index + 1);
            return vehicle;
        })
        _.set(submissionVM, vehiclesList, 'lobData.businessAuto.coverables.vehicles.value')
        _.unset(submissionVM.value, 'bindData');
        submissionVM.value = await LoadSaveService.updateDraftSubmission(
            submissionVM.value,
            authHeader
        );
        return submissionVM;
    }, [LoadSaveService, authHeader, submissionVM]);

    const overrideProps = {
        '@field': {
            showOptional: false,
            showRequired: true,
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top'
        },
        addVehicle: {
            disabled: !validateVehicles()
        },
        ...generateOverrides()
    };

    const resolvers = {
        resolveCallbackMap: {
            onAddVehicleClick: addVehicle,
            onAddAdditionalInterest: addAdditionalInterest,
            onRemoveVehicle: removeVehicle,
            onValidate
        },
        resolveComponentMap: {
            additionalinterestcomponent: AdditionalInterestComponent
        }
    };

    const isSubmissionQuoted = useCallback(() => {
        return _.get(submissionVM.value, 'baseData.periodStatus') === 'Quoted';
    }, [submissionVM]);

    const readValue = useCallback(
        (id, path) => {
            return readViewModelValue(metadata.pageContent, submissionVM, id, path, overrideProps);
        },
        [submissionVM, overrideProps]
    );

    useEffect(() => {
        registerInitialComponentValidation(isSubmissionQuoted);
    }, [isSubmissionQuoted, registerInitialComponentValidation]);

    if (!isPageInitialised) {
        return null;
    }

    return (
        <WizardPage onNext={onNext} skipWhen={initialValidation} disableNext={!validateTelematics() || !validateVehicles() || garageLocationDetailsValidation}>
            <ViewModelForm
                uiProps={metadata.pageContent}
                model={submissionVM}
                onModelChange={updateWizardData}
                overrideProps={overrideProps}
                onValidationChange={onValidate}
                resolveValue={readValue}
                callbackMap={resolvers.resolveCallbackMap}
                componentMap={resolvers.resolveComponentMap}
                classNameMap={styles}
            />
        </WizardPage>
    );
}

VehiclesPage.propTypes = wizardProps;
export default VehiclesPage;
